// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"126":"[auth]","285":"[Home]","631":"[profile]"}[chunkId] || chunkId) + "." + {"126":"3864e5ab","285":"90ad5b6a","387":"54bda73f","517":"ee178228","631":"d899899a","787":"4a21b8e5","996":"adcd8038"}[chunkId] + ".chunk.js";
};